import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
class VideoController {
  constructor() {
    iamotaEventHandler.subscribe('productForm:gallery:video:init', this.init.bind(this), {
      source: "videoController.js"
    });
  }
  init(_ref) {
    var ProductVideo = _ref.ProductVideo,
      video = _ref.video;
    this.ProductVideo = ProductVideo;
    iamotaEventHandler.subscribe('productForm:gallery:video:mediaHidden', this.onMediaHidden.bind(this), {
      source: "videoController.js"
    });
    iamotaEventHandler.subscribe('productForm:gallery:video:mediaVisible', this.onMediaVisible.bind(this), {
      source: "videoController.js"
    });
    if (!this.isSupported(video.element)) return;
    this.createPlayer(video);
  }
  onMediaHidden(_ref2) {
    var mediaId = _ref2.mediaId;
    this.handleMediaEvent('productForm:gallery:video:mediaHidden', mediaId);
  }
  onMediaVisible(_ref3) {
    var mediaId = _ref3.mediaId;
    this.handleMediaEvent('productForm:gallery:video:mediaVisible', mediaId);
  }
  handleMediaEvent(event, mediaId) {
    var video = this.findVideoByElement(mediaId);
    if (!video || !this.isSupported(video.element)) return;
    if (event === 'productForm:gallery:video:mediaHidden') {
      this.pauseVideo(video);
    } else if (event === 'productForm:gallery:video:mediaVisible') {
      this.playVideo(video);
    }
  }
  findVideoByElement(mediaId) {
    return Object.values(this.ProductVideo.videos).find(video => video.mediaId === mediaId);
  }

  // Methods to be overridden by subclasses
  getPlayerType() {
    throw new Error('getPlayerType method must be implemented by subclass');
  }
  isSupported(_videoElement) {
    throw new Error('isSupported method must be implemented by subclass');
  }
  createPlayer(_video) {
    throw new Error('createPlayer method must be implemented by subclass');
  }
  pauseVideo(_video) {
    throw new Error('pauseVideo method must be implemented by subclass');
  }
  playVideo(_video) {
    throw new Error('playVideo method must be implemented by subclass');
  }
}
export default VideoController;